import {ComputedRef, InjectionKey} from "vue";

export const RouteNameInjectionKey = Symbol() as InjectionKey<ComputedRef<string | Symbol>>;
export const IsRouteActivatedKey = Symbol() as InjectionKey<ComputedRef<boolean>>;